import { styled } from '@presov.sk/presov-ui-react';
import { Link as ReactLink } from 'react-router';

export const Link = styled(ReactLink)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.text.primary,
}));
